import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from "../util/tss-react/index.js";
const useStyles = makeStyles()({
    flexContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
});
export default function DataGridFlexContainer({ children, style, }) {
    const { classes } = useStyles();
    return (_jsx("div", { className: classes.flexContainer, style: style, children: children }));
}
